import { render, staticRenderFns } from "./AuditClinicalNoteDialog.vue?vue&type=template&id=484546ef&"
import script from "./AuditClinicalNoteDialog.vue?vue&type=script&lang=js&"
export * from "./AuditClinicalNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports